export const messages = {
    msgAlreadyHaveUser: 'Already have an Orka user?',
};
